module.exports = __webpack_public_path__ + "static/media/smf.80adc73f.png";